import { useCallback, useMemo } from 'react';

import { createStorage, useStorageString } from '@sg/mmkv-storage';

// ─────────────────────────────────────────────────────────────────────────────

export const useNavbarNewContentIndicator = (links: string[]) => {
  const [lastSeenLinks, setLastSeenLinks] = useStorageString(LAST_SEEN_LINKS_KEY, STORAGE);

  // ─── Derived ─────────────────────────────────────────────────────────

  const unseenLinks = useMemo(() => {
    // Handles first time users, no links are considered new.
    if (!lastSeenLinks) return new Set<string>();

    const seenLinks = lastSeenLinks.split(',');

    return new Set(links.filter((link) => !seenLinks.includes(link)));
  }, [lastSeenLinks, links]);

  // ─── Handlers ────────────────────────────────────────────────────────

  const storeLastSeenLinks = useCallback(() => {
    setLastSeenLinks(links.join(','));
  }, [links, setLastSeenLinks]);

  return {
    hasNewContent: unseenLinks.size > 0,
    unseenLinks,
    storeLastSeenLinks,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const STORAGE = createStorage({ id: 'sg.navbar' });
const LAST_SEEN_LINKS_KEY = 'navbar-last-seen-links';
